import React from "react";

const svgStyles = {
  cursor: "pointer",
};

const FilesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={12}
    fill="none"
    style={svgStyles}
    {...props}
  >
    <path
      style={svgStyles}
      fill="#9B27AF"
      d="M10.25 0H5a1.5 1.5 0 0 0-1.5 1.5A1.5 1.5 0 0 0 2 3v7.5A1.5 1.5 0 0 0 3.5 12h5.25a1.5 1.5 0 0 0 1.5-1.5 1.5 1.5 0 0 0 1.5-1.5V1.5a1.5 1.5 0 0 0-1.5-1.5Zm0 9.75V3a1.5 1.5 0 0 0-1.5-1.5h-4.5A.75.75 0 0 1 5 .75h5.25a.75.75 0 0 1 .75.75V9a.75.75 0 0 1-.75.75ZM2.75 3a.75.75 0 0 1 .75-.75h5.25A.75.75 0 0 1 9.5 3v7.5a.75.75 0 0 1-.75.75H3.5a.75.75 0 0 1-.75-.75V3Z"
    />
  </svg>
);
export default FilesIcon;
